// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vwyuufoxravkdroyqfps.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ3eXV1Zm94cmF2a2Ryb3lxZnBzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY2NzU4MjYsImV4cCI6MjA1MjI1MTgyNn0.kyFgclFJGTPJoTmbODB9f21YvQp-9LJHe0lA6V0HpSQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);